/* CB-CUSTOM 2026-10-17 (Grok tema): billedpile + hurtigkøb på produktkort (kollektionsside). */
import Cart from "cart-store";
const W = [180, 360, 540, 720, 900];
function srcset(u) { return W.map(w => u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w').join(', '); }
function vis(card, step) {
  const data = card.querySelector('.cb-kort__billeder');
  const img = card.querySelector('.product-card__img');
  if (!data || !img) return;
  const list = card._cbImgs || (card._cbImgs = JSON.parse(data.textContent));
  if (card._cbIdx == null) card._cbIdx = +(data.dataset.start || 0) % list.length;
  const n = (card._cbIdx + step + list.length) % list.length;
  card._cbIdx = n;
  const u = list[n];
  // 2: hent billedet færdigt før det skiftes, så feltet aldrig står hvidt
  const pre = new Image(); pre.sizes = img.sizes; pre.srcset = srcset(u); pre.src = u;
  const skift = () => { if (card._cbIdx !== n) return; img.removeAttribute('data-srcset'); img.srcset = pre.srcset; img.src = u; img.loading = 'eager'; img.style.opacity = '1'; img.style.visibility = 'visible'; card.classList.add('cb-slid'); };
  (pre.decode ? pre.decode() : Promise.resolve()).then(skift, skift);
  const next = new Image(); next.sizes = img.sizes; next.srcset = srcset(list[(n + 1) % list.length]);
}
async function laeg(btn) {
  const card = btn.closest('product-card');
  btn.classList.add('is-busy'); btn.disabled = true;
  try {
    await Cart.add({ id: btn.dataset.cbVariant, quantity: 1 });
    btn.classList.remove('is-busy'); btn.classList.add('is-done');
    try { await Cart.resetVariantsBeingAdded(); } catch (e) {}
    const c = document.querySelector('.modal--cart, .popup--cart-notification');
    if (c && !c.shown && c.open) c.open(); else if (c && c.interval) { c.interval.reset(); c.interval.start(); }
    setTimeout(() => { btn.classList.remove('is-done'); btn.disabled = false; card && card.classList.remove('cb-open'); }, 1500);
  } catch (e) {
    btn.classList.remove('is-busy'); btn.disabled = false;
    console.warn('cb-kort', e);
  }
}
document.addEventListener('click', e => {
  const pil = e.target.closest('[data-cb-pil]');
  if (pil) { e.preventDefault(); e.stopPropagation(); vis(pil.closest('product-card'), +pil.dataset.cbPil); if (e.detail) pil.blur(); return; }
  const plus = e.target.closest('[data-cb-plus]');
  if (plus) { e.preventDefault(); e.stopPropagation(); arkAabn(plus); return; }
  const av = e.target.closest('[data-cb-ark] [data-cb-variant]');
  if (av) { e.preventDefault(); if (!av.disabled) arkLaeg(av); return; }
  if (e.target.closest('[data-cb-ark-luk]')) { e.preventDefault(); arkLuk(); return; }
  const v = e.target.closest('[data-cb-koeb] [data-cb-variant]');
  if (v) { e.preventDefault(); e.stopPropagation(); if (!v.disabled) laeg(v); }
}, true);

/* CB-CUSTOM 2026-10-18: mobil bundark til størrelser (som bjornborg.com) */
let ark = null, arkFra = null;
function arkByg() {
  if (ark) return ark;
  ark = document.createElement('div'); ark.className = 'cb-ark'; ark.hidden = true; ark.setAttribute('data-cb-ark', '');
  ark.innerHTML = '<div class="cb-ark__dim" data-cb-ark-luk></div><div class="cb-ark__panel" role="dialog" aria-modal="true" aria-labelledby="cb-ark-titel"><div class="cb-ark__top"><p class="cb-ark__titel" id="cb-ark-titel"></p><button type="button" class="cb-ark__x" data-cb-ark-luk><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button></div><div class="cb-ark__str"></div></div>';
  document.body.appendChild(ark);
  return ark;
}
function arkAabn(plus) {
  const card = plus.closest('product-card, [data-cb-kb]'); const a = arkByg();
  a.querySelector('.cb-ark__titel').textContent = plus.dataset.cbTitel || '';
  a.querySelector('.cb-ark__x').setAttribute('aria-label', plus.dataset.cbLuk || 'Luk');
  const str = a.querySelector('.cb-ark__str'); str.innerHTML = '';
  card.querySelectorAll('[data-cb-koeb] [data-cb-variant]').forEach(b => {
    const n = document.createElement('button'); n.type = 'button'; n.className = 'cb-ark__knap'; n.dataset.cbVariant = b.dataset.cbVariant;
    n.textContent = b.textContent.trim(); if (b.disabled) { n.disabled = true; n.setAttribute('aria-label', b.getAttribute('aria-label') || n.textContent); }
    str.appendChild(n);
  });
  arkFra = plus; a.hidden = false; document.documentElement.classList.add('cb-ark-laast');
  requestAnimationFrame(() => requestAnimationFrame(() => a.classList.add('is-aaben')));
  const f = str.querySelector('button:not([disabled])') || a.querySelector('.cb-ark__x'); f && f.focus({ preventScroll: true });
}
function arkLuk() {
  if (!ark || ark.hidden) return;
  ark.classList.remove('is-aaben'); document.documentElement.classList.remove('cb-ark-laast');
  setTimeout(() => { if (!ark.classList.contains('is-aaben')) ark.hidden = true; }, 250);
  if (arkFra) arkFra.focus({ preventScroll: true });
}
async function arkLaeg(btn) {
  btn.classList.add('is-busy'); btn.disabled = true;
  try {
    await Cart.add({ id: btn.dataset.cbVariant, quantity: 1 });
    try { await Cart.resetVariantsBeingAdded(); } catch (e) {}
    arkLuk();
    const c = document.querySelector('.modal--cart, .popup--cart-notification');
    if (c && !c.shown && c.open) c.open(); else if (c && c.interval) { c.interval.reset(); c.interval.start(); }
  } catch (e) { console.warn('cb-kort', e); }
  btn.classList.remove('is-busy'); btn.disabled = false;
}
document.addEventListener('keydown', e => { if (e.key === 'Escape') arkLuk(); });
let sx = 0, sy = 0, kort = null;
document.addEventListener('touchstart', e => {
  const t = e.target.closest('.cb-kort-on .product-card-top'); kort = t ? t.closest('product-card') : null;
  if (kort) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
}, { passive: true });
document.addEventListener('touchend', e => {
  if (!kort) return;
  const k = kort;
  const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
  if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
    vis(k, dx < 0 ? 1 : -1);
    const stop = ev => { ev.preventDefault(); ev.stopPropagation(); };
    k.addEventListener('click', stop, { capture: true, once: true });
    setTimeout(() => k.removeEventListener('click', stop, true), 400);
  }
  kort = null;
}, { passive: true });

/* Fremdriftslinje under "Relaterede varer"-slideren (produktsiden) */
function cbFremdrift(scroller) {
  /* t147u: slået fra – ingen fremdriftslinjer (t138u) */ document.querySelectorAll('.cb-fremdrift').forEach(b => b.remove()); return;
  const host = scroller.closest('items-scroll-paged-navigation');
  if (!host) return;
  let bar = host.parentElement.querySelector(':scope > .cb-fremdrift');
  if (!bar) { bar = document.createElement('div'); bar.className = 'cb-fremdrift'; bar.innerHTML = '<span></span>'; host.after(bar); }
  const sw = scroller.scrollWidth, cw = scroller.clientWidth;
  const andel = sw > 0 ? Math.min(1, cw / sw) : 1;
  const pos = sw > cw ? scroller.scrollLeft / (sw - cw) : 0;
  const s = bar.firstChild; s.style.width = (andel * 100) + '%'; s.style.left = (pos * (1 - andel) * 100) + '%';
  bar.hidden = andel >= 0.999;
}
function cbFindFremdrift() { document.querySelectorAll('[id$="__product-recommendations"] [data-items]').forEach(cbFremdrift); }
document.addEventListener('scroll', e => { const t = e.target; if (t && t.matches && t.matches('[id$="__product-recommendations"] [data-items]')) cbFremdrift(t); }, true);
let cbFT = null;
new MutationObserver(() => { clearTimeout(cbFT); cbFT = setTimeout(cbFindFremdrift, 150); }).observe(document.documentElement, { childList: true, subtree: true });
window.addEventListener('resize', cbFindFremdrift);

/* CB-CUSTOM 2026-10-17: "599 kr" i annoncebjælken vises i besøgendes valuta (samme omregning som gave.js: 599 DKK × Shopify.currency.rate, rundet op til helt beløb, fx 81 €) */
(function () {
  const C = window.Shopify && Shopify.currency;
  if (!C || !C.active || C.active === 'DKK') return;
  const beloeb = Math.ceil(599 * (Number(C.rate) || 1));
  const sprog = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
  const land = (window.Shopify && Shopify.country) || '';
  let tekst;
  try { tekst = new Intl.NumberFormat(sprog + (land ? '-' + land : ''), { style: 'currency', currency: C.active, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(beloeb); }
  catch (e) { tekst = beloeb + ' ' + C.active; }
  const ret = () => document.querySelectorAll('.announcement__wrapper, announcement-bar, .announcement').forEach(el => {
    const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let n; while ((n = w.nextNode())) { if (/599\s*kr\.?/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/599\s*kr\.?/gi, tekst); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ret); else ret();
})();

/* CB-CUSTOM 2026-10-18: mobil produktgalleri som bjornborg.com – ét billede ad gangen, swipe med scroll-snap, tynd fremdriftslinje. Desktop uændret. */
(function () {
  const mq = window.matchMedia('(max-width: 767px)');
  function byg() {
    const g = document.querySelector('.template-product media-gallery.media-gallery, .template-product .media-gallery');
    if (!g) return;
    /* CB-CUSTOM 2026-10-19 hastighed: galleriet er server-renderet i snippets/product-gallery.liquid – her kobles kun fremdriftslinjen på */
    const ssr = g.querySelector('.cb-mgal[data-cb-mgal-ssr]');
    if (ssr) {
      if (ssr.dataset.klar) return; ssr.dataset.klar = '1';
      const spor = ssr.querySelector('.cb-mgal__spor'), del = ssr.querySelector('.cb-mgal__linje span');
      const n = spor.children.length;
      const opd = () => { const max = spor.scrollWidth - spor.clientWidth; const p = max > 0 ? spor.scrollLeft / max : 0; if (del) del.style.left = (p * (100 - 100 / n)) + '%'; };
      spor.addEventListener('scroll', opd, { passive: true }); opd();
      document.documentElement.classList.add('cb-mgal-on');
      return;
    }
    if (g.querySelector('.cb-mgal')) return;
    const imgs = [...g.querySelectorAll('.js-slides .media-gallery__item--image img.media-gallery__image')];
    if (!imgs.length) return;
    const r = g.querySelector('.js-slides .o-ratio');
    const ratio = r ? r.style.paddingBottom : '116.6667%';
    const w = document.createElement('div'); w.className = 'cb-mgal';
    const spor = document.createElement('div'); spor.className = 'cb-mgal__spor'; spor.tabIndex = 0;
    imgs.forEach((s, i) => {
      const f = document.createElement('div'); f.className = 'cb-mgal__felt'; f.style.paddingBottom = ratio;
      const im = document.createElement('img'); im.src = s.getAttribute('src'); im.srcset = s.getAttribute('srcset') || ''; im.sizes = '100vw';
      im.alt = s.getAttribute('alt') || ''; im.loading = i ? 'lazy' : 'eager'; im.decoding = 'async';
      f.appendChild(im); spor.appendChild(f);
    });
    const linje = document.createElement('div'); linje.className = 'cb-mgal__linje'; linje.setAttribute('aria-hidden', 'true');
    const del = document.createElement('span'); linje.appendChild(del);
    w.append(spor, linje); g.prepend(w);
    const n = imgs.length; del.style.width = (100 / n) + '%'; linje.hidden = n < 2;
    const opd = () => { const max = spor.scrollWidth - spor.clientWidth; const p = max > 0 ? spor.scrollLeft / max : 0; del.style.left = (p * (100 - 100 / n)) + '%'; };
    spor.addEventListener('scroll', opd, { passive: true }); opd();
    document.documentElement.classList.add('cb-mgal-on');
  }
  function start() { if (mq.matches) byg(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  mq.addEventListener ? mq.addEventListener('change', start) : mq.addListener(start);
})();

/* CB-CUSTOM 2026-10-18: fast købsbjælke på mobil-produktsiden (snippets/cb-buybar.liquid) */
(function () {
  const kb = document.querySelector('[data-cb-kb]');
  if (!kb) return;
  document.body.appendChild(kb); kb.hidden = false;
  const form = document.querySelector('.template-product product-form form[action*="/cart/add"], product-form form[action*="/cart/add"]');
  const hoved = form && form.querySelector('[type=submit]');
  const knap = kb.querySelector('[data-cb-kb-knap]'), strL = kb.querySelector('[data-cb-kb-str]');
  const mode = kb.dataset.mode; let valgt = null;
  const varianter = [...kb.querySelectorAll('.cb-kb__varianter [data-cb-variant]')];
  function vis() {
    if (mode === 'str') {
      if (valgt) { knap.textContent = kb.dataset.tA; strL.hidden = false; strL.textContent = kb.dataset.tS + ': ' + valgt.textContent.trim();
        kb.querySelector('.cb-kb__nu').textContent = valgt.dataset.pris; const f = kb.querySelector('.cb-kb__foer'); if (f && valgt.dataset.foer) f.textContent = valgt.dataset.foer; }
      else { knap.textContent = kb.dataset.tV; strL.hidden = true; }
    }
  }
  function laesForm() {
    if (mode !== 'str' || !form) return;
    const id = (form.querySelector('[name=id]') || {}).value;
    const v = varianter.find(b => b.dataset.cbVariant === String(id));
    if (v && !v.disabled) { valgt = v; vis(); }
  }
  // kun en aktiv handling i produktformularen tæller som "valgt størrelse" (temaet forvælger første variant)
  const omr = form && (form.closest('.product-single, .product, section') || form);
  if (omr) ['change', 'click'].forEach(t => omr.addEventListener(t, e => { if (!e.isTrusted || kb.contains(e.target)) return; if (e.target.closest('[type=submit]')) return; setTimeout(laesForm, 60); }, true));
  if (/[?&]variant=/.test(location.search)) laesForm();
  async function koeb(id) {
    knap.disabled = true;
    try {
      await Cart.add({ id: id, quantity: 1 }); try { await Cart.resetVariantsBeingAdded(); } catch (e) {}
      const c = document.querySelector('.modal--cart, .popup--cart-notification');
      if (c && !c.shown && c.open) c.open(); else if (c && c.interval) { c.interval.reset(); c.interval.start(); }
    } catch (e) { console.warn('cb-kb', e); }
    knap.disabled = false;
  }
  knap.addEventListener('click', e => {
    e.preventDefault();
    if (mode === 'flere') { (form || document.body).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    if (mode === 'en') { if (varianter[0]) koeb(varianter[0].dataset.cbVariant); return; }
    if (valgt) koeb(valgt.dataset.cbVariant); else arkAabn(knap);
  });
  if (hoved && 'IntersectionObserver' in window) {
    new IntersectionObserver(es => es.forEach(x => { kb.classList.toggle('cb-kb--skjult', x.isIntersecting); document.documentElement.classList.toggle('cb-kb-synlig', !x.isIntersecting); }), { threshold: 0 }).observe(hoved);
  }
  else document.documentElement.classList.add('cb-kb-synlig');
  document.documentElement.classList.add('cb-kb-on');
})();

/* CB-CUSTOM 2026-10-18 (Michael t70u): ~20 % livsstilsbilleder. Pr. slider/gitter vises livsstilsbilledet på første egnede kort
   og derefter tidligst 5 kort efter forrige (kun kort med data-liv > 0; ellers næste egnede). Resten viser packshot. */
function cbLivFordel() {
  document.querySelectorAll('product-card').forEach(card => {
    if (card._cbLivTjek) return;
    const data = card.querySelector('.cb-kort__billeder');
    if (!data) return;
    card._cbLivTjek = true;
    if (card.closest('.cb-komb')) return; /* CB-CUSTOM 2026-10-18 (t95u): Kombiner med forbliver packshot */
    const grp = card.closest('[data-items]') || card.closest('.shopify-section') || document.body;
    if (grp._cbGap == null) grp._cbGap = 4;
    const liv = +(data.dataset.liv || 0);
    if (liv > 0 && grp._cbGap >= 4) { vis(card, liv); card.classList.add('cb-liv'); grp._cbGap = 0; }
    else grp._cbGap++;
  });
}
cbLivFordel();
document.addEventListener('DOMContentLoaded', cbLivFordel);
new MutationObserver(() => cbLivFordel()).observe(document.documentElement, { childList: true, subtree: true });

/* CB-CUSTOM 2026-10-18 (out52): skærmlæsertekst på pagineringens pile (teksten er skjult visuelt) */
(function () {
  const L = (document.documentElement.lang || 'da').slice(0, 2);
  const T = { da: ['Forrige side', 'Næste side'], sv: ['Föregående sida', 'Nästa sida'], de: ['Vorherige Seite', 'Nächste Seite'], en: ['Previous page', 'Next page'] }[L] || ['Forrige side', 'Næste side'];
  const s = () => document.querySelectorAll('.pagination__items > .prev > a, .pagination__items > .next > a').forEach(a => { if (!a.getAttribute('aria-label')) a.setAttribute('aria-label', a.parentElement.classList.contains('prev') ? T[0] : T[1]); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', s); else s();
})();

/* CB-CUSTOM 2026-10-18 (Michael t106u): hover viser næste billede på alle produktkort (desktop med mus).
   Kort med livsstilsbillede først viser næste billede (packshot) ved hover; ved mouseleave vendes tilbage. */
(function () {
  const mus = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.addEventListener('mouseover', e => {
    if (!mus.matches) return;
    const card = e.target.closest && e.target.closest('product-card');
    if (!card || card._cbHov != null || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    const data = card.querySelector('.cb-kort__billeder');
    if (!data) return;
    const list = card._cbImgs || (card._cbImgs = JSON.parse(data.textContent));
    if (list.length < 2) return;
    if (card._cbIdx == null) card._cbIdx = +(data.dataset.start || 0) % list.length;
    card._cbHov = card._cbIdx;
    vis(card, 1);
  });
  document.addEventListener('mouseout', e => {
    const card = e.target.closest && e.target.closest('product-card');
    if (!card || card._cbHov == null || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    const t = card._cbHov; card._cbHov = null;
    if (card._cbIdx !== t) { card._cbIdx = t; vis(card, 0); }
  });
  /* pilene ændrer billedet mens musen er over kortet: behold det valgte ved mouseleave */
  document.addEventListener('click', e => { const p = e.target.closest && e.target.closest('[data-cb-pil]'); const c = p && p.closest('product-card'); if (c && c._cbHov != null) setTimeout(() => { c._cbHov = c._cbIdx; }, 0); }, true);
})();

/* CB-CUSTOM 2026-10-18 (Michael t112u, t120u): faste afstande står i cb-header.css. Dette script finjusterer KUN sektioner under synsfeltet (fx kollektionsbeskrivelser, hvis afstand afhænger af indholdet), så der aldrig ses et hop.: ens synlig afstand mellem sektioner på produkt-, kollektions- og indholdssider
   (36px desktop / 28px mobil, som forsiden). Måler synligt indhold og justerer margin-top pr. sektion. */
(function () {
  if (!/template-collection/.test(document.body.className)) return;
  const BLAD = ['IMG', 'SVG', 'H1', 'H2', 'H3', 'H4', 'P', 'A', 'BUTTON', 'PICTURE', 'VIDEO', 'IFRAME', 'INPUT', 'SELECT', 'LI'];
  function kant(sek) {
    const R = sek.getBoundingClientRect(); let top = Infinity, bund = -Infinity;
    (function gaa(n) {
      for (const c of n.children) {
        const s = getComputedStyle(c);
        if (s.display === 'none' || s.visibility === 'hidden' || s.position === 'fixed' || s.position === 'sticky' || +s.opacity === 0) continue;
        const r = c.getBoundingClientRect();
        if (r.height === 0 || r.width === 0) continue;
        if (c.children.length === 0 || BLAD.includes(c.tagName.toUpperCase())) {
          if (r.right <= 0 || r.left >= innerWidth) continue;
          const t = Math.max(r.top, R.top), b = Math.min(r.bottom, R.bottom);
          if (b > t) { top = Math.min(top, t); bund = Math.max(bund, b); }
        } else gaa(c);
      }
    })(sek);
    return top === Infinity ? null : { top: top + scrollY, bund: bund + scrollY };
  }
  let koerer = false;
  function juster() {
    if (koerer) return; koerer = true;
    const maal = innerWidth <= 767 ? 28 : 36;
    const S = [...document.querySelectorAll('#main .shopify-section')].filter(s => !s.parentElement.closest('.shopify-section') && s.getBoundingClientRect().height > 2);
    let forrige = null;
    for (const s of S) {
      const k = kant(s);
      if (!k) continue;
      if (forrige && /__description$/.test(s.id) && /template-collection/.test(document.body.className) && s.getBoundingClientRect().top > innerHeight + 50) {
        const nu = parseFloat(getComputedStyle(s).marginTop) || 0;
        const ny = Math.round(nu + (maal - (k.top - forrige.bund)));
        if (Math.abs(ny - nu) > 1) { s.style.setProperty('margin-top', ny + 'px', 'important'); }
        forrige = kant(s) || k;
      } else forrige = k;
    }
    koerer = false;
  }
  let tm = null; const senere = () => { clearTimeout(tm); tm = setTimeout(juster, 250); };
  /* første justering straks (før billeder), så der ikke ses et hop */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', juster); else juster();
  window.addEventListener('load', juster);
  setTimeout(juster, 2500); setTimeout(juster, 6000);
})();

/* CB-CUSTOM 2026-10-18 (Michael t120u): "Sorter efter" viste tom værdi – temaets oversættelse for "manual"/"most-relevant" mangler (også på live). Udfyld tomme valg. */
(function () {
  const L = (document.documentElement.lang || 'da').slice(0, 2);
  const T = { da: { manual: 'Anbefalet', 'most-relevant': 'Mest relevante' }, sv: { manual: 'Rekommenderade', 'most-relevant': 'Mest relevanta' }, de: { manual: 'Empfohlen', 'most-relevant': 'Relevanteste' }, en: { manual: 'Featured', 'most-relevant': 'Most relevant' } }[L] || { manual: 'Anbefalet', 'most-relevant': 'Mest relevante' };
  /* dansk: temaets oversættelser har også engelsk "Alphabet" og dobbelte pris-/dato-tekster – sæt alle */
  const DA = { 'manual': 'Anbefalet', 'most-relevant': 'Mest relevante', 'best-selling': 'Bestsellers', 'title-ascending': 'Alfabetisk, A-Å', 'title-descending': 'Alfabetisk, Å-A', 'price-ascending': 'Pris, lav til høj', 'price-descending': 'Pris, høj til lav', 'created-ascending': 'Dato, gammel til ny', 'created-descending': 'Dato, ny til gammel' };
  const fyld = () => document.querySelectorAll('select[name="sort_by"] option').forEach(o => { const t = L === 'da' ? DA[o.value] : (!o.textContent.trim() && T[o.value]); if (t && o.textContent.trim() !== t) o.textContent = t; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fyld); else fyld();
  new MutationObserver(() => fyld()).observe(document.documentElement, { childList: true, subtree: true });
})();

/* CB-CUSTOM 2026-10-18 (Michael t125u): swipe mellem produktbilleder på touch (som bjornborg.com). Native CSS scroll-snap i kortets billedfelt,
   ingen pile. Lodret scroll virker normalt (touch-action: pan-x pan-y); ved første/sidste billede kæder swipet videre til ydre slider.
   Tryk åbner produktet (feltet ligger inde i kortets link). Første billede = det kortet allerede viser (livsstil/packshot-reglerne bevares). Desktop: uændret hover. */
(function () {
  return; /* CB-CUSTOM 2026-10-18 (Michael t137u): billedswipe i kortene slået fra overalt; sliderne swipes i stedet. Fjern denne linje for at genaktivere t125u. */
  const touch = window.matchMedia('(hover: none) and (pointer: coarse)');
  const st = document.createElement('style');
  st.textContent = '.cb-swipe{position:absolute;inset:0;z-index:2;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;touch-action:pan-x pan-y;overscroll-behavior-x:auto}'
    + '.cb-swipe::-webkit-scrollbar{display:none}.cb-swipe img{flex:0 0 100%;width:100%;height:100%;object-fit:cover;scroll-snap-align:start;scroll-snap-stop:always;display:block;-webkit-user-drag:none;user-select:none}'
    + '.cb-swipe-on .cb-kort__pil{display:none!important}';
  document.head.appendChild(st);
  function byg(card) {
    if (card._cbSw) return;
    const data = card.querySelector('.cb-kort__billeder');
    const media = card.querySelector('.product-card__media');
    const img = card.querySelector('.product-card__img');
    if (!data || !media || !img) return;
    card._cbSw = true;
    const list = card._cbImgs || (card._cbImgs = JSON.parse(data.textContent));
    if (list.length < 2) return;
    const start = card._cbIdx != null ? card._cbIdx : +(data.dataset.start || 0) % list.length;
    const fit = getComputedStyle(img).objectFit || 'cover';
    const box = document.createElement('div'); box.className = 'cb-swipe';
    for (let k = 0; k < list.length; k++) {
      const u = list[(start + k) % list.length];
      const i = document.createElement('img');
      i.alt = ''; i.draggable = false; i.decoding = 'async'; i.loading = k === 0 ? 'eager' : 'lazy';
      i.sizes = img.sizes || '50vw'; i.srcset = srcset(u); i.src = u; i.style.objectFit = fit;
      box.appendChild(i);
    }
    media.appendChild(box);
    card.classList.add('cb-swipe-on');
  }
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { io.unobserve(e.target); byg(e.target); } }), { rootMargin: '300px' }) : null;
  function scan() {
    if (!touch.matches) return;
    document.querySelectorAll('product-card:not([data-cb-sw])').forEach(c => { c.setAttribute('data-cb-sw', ''); io ? io.observe(c) : byg(c); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(scan, 150); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* CB-CUSTOM 2026-10-18 (Michael t132u): produktsidens "Udvalgte produkter til dig" – fjern varer der allerede vises i Kombiner med / Relaterede (og dubletter),
   vis højst 12. Listen selv beregnes i snippets/cb-pdp-mix.liquid (kontekst dame/herre/unisex). */
(function () {
  if (!/template-product/.test(document.body.className)) return;
  const hk = el => { const a = el.querySelector('a[href*="/products/"]'); const m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? m[1] : null; };
  function ryd() {
    const sek = document.querySelector('[id$="__udvalgte_produkter"]');
    if (!sek) return;
    const set = new Set();
    document.querySelectorAll('.cb-komb product-card, product-recommendations product-card, [id$="__product-recommendations"] product-card').forEach(c => { const h = hk(c); if (h) set.add(h); });
    const m = location.pathname.match(/\/products\/([^/?#]+)/); if (m) set.add(m[1]);
    const grid = sek.querySelector('[data-items]') || sek.querySelector('.grid-layout');
    if (!grid) return;
    let vist = 0;
    [...grid.children].forEach(it => {
      const h = hk(it);
      const skjul = !h || set.has(h) || vist >= 12;
      it.style.display = skjul ? 'none' : '';
      if (!skjul) { set.add(h); vist++; }
    });
    sek.dataset.cbVist = vist;
  }
  const kør = () => { ryd(); setTimeout(ryd, 1500); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kør); else kør();
  let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(ryd, 200); }).observe(document.body, { childList: true, subtree: true });
})();

/* CB-CUSTOM 2026-10-18 (Michael t133u): tynd progressbar under vandrette slidere på mobil (mørkt segment på lysegråt spor) */
(function () {
  return; /* t138u: ingen progressbar på slidere (Michael) */
  function byg(nav) {
    if (nav.querySelector(':scope > .cb-prog')) return;
    const g = nav.querySelector(':scope > .grid-layout');
    if (!g) return;
    const p = document.createElement('div'); p.className = 'cb-prog'; p.setAttribute('aria-hidden', 'true');
    const b = document.createElement('div'); b.className = 'cb-prog__bar'; p.appendChild(b);
    nav.appendChild(p);
    const opd = () => {
      const sw = g.scrollWidth, cw = g.clientWidth;
      if (sw <= cw + 2) { p.style.visibility = 'hidden'; return; }
      p.style.visibility = '';
      /* t135u: 12px under nederste tekst/billede i det første synlige kort */
      let bund = 0;
      g.querySelectorAll(':scope > * *').forEach(e => { if (!e.children.length && e.offsetHeight) bund = Math.max(bund, e.getBoundingClientRect().bottom); });
      if (!bund) [...g.children].forEach(e => { if (e.offsetWidth) bund = Math.max(bund, e.getBoundingClientRect().bottom); });
      if (bund) { p.style.top = Math.round(bund - nav.getBoundingClientRect().top + 12) + 'px'; p.style.bottom = 'auto'; }
      const andel = cw / sw, tw = p.clientWidth * andel;
      b.style.width = tw + 'px';
      b.style.transform = 'translateX(' + ((p.clientWidth - tw) * (g.scrollLeft / (sw - cw))) + 'px)';
    };
    g.addEventListener('scroll', opd, { passive: true });
    window.addEventListener('resize', opd);
    opd(); setTimeout(opd, 1500); setTimeout(opd, 4000); window.addEventListener('load', opd); if (window.ResizeObserver) new ResizeObserver(() => opd()).observe(g); let raf = 0; window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; const r = nav.getBoundingClientRect(); if (r.bottom > -200 && r.top < innerHeight + 200) opd(); }); }, { passive: true });
  }
  const scan = () => document.querySelectorAll('items-scroll-paged-navigation').forEach(byg);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(scan, 200); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* CB-CUSTOM 2026-10-18 (Michael t134u/t135u): mobilmenu – logo i toppen af skuffen og "Danmark" som synlig landetekst */
(function () {
  function op() {
    const m = document.querySelector('modal-dialog.modal--main-menu');
    if (!m || m._cbDr) return;
    const top = m.querySelector('.modal__content > .drawer-nav__empty-banner');
    const img = document.querySelector('header-container .header__logo-img');
    if (!top || !img) return;
    m._cbDr = true;
    const a = document.createElement('a'); a.href = '/'; a.className = 'cb-dr-logo'; a.setAttribute('aria-label', img.alt || 'Forside');
    const i = img.cloneNode(true); i.removeAttribute('itemprop'); i.loading = 'lazy'; a.appendChild(i); top.appendChild(a);
    const t = m.querySelector('.mobile-draw__localize .cb-land-tekst');
    if (t) t.textContent = t.textContent.replace(/\s*\([\s\S]*\)\s*$/, '');
  }
  const land = () => { const t = document.querySelector('modal-dialog.modal--main-menu .mobile-draw__localize .cb-land-tekst'); if (t && /\(/.test(t.textContent)) t.textContent = t.textContent.replace(/\s*\([\s\S]*\)\s*$/, ''); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', op); else op();
  setTimeout(op, 2000);
  document.addEventListener('click', e => { if (e.target.closest && e.target.closest('.header-trigger')) { op(); land(); setTimeout(land, 300); } }, true);
})();

/* CB-CUSTOM 2026-10-18 (Michael t146u): mobilmenu bund – to rene tekstlinks (som woodwood "Kontakt / Levering og returnering") over flag+Danmark. Erstatter mail/telefon (skjult i cb-header.css). Eksisterende sider, Shopify-navigation urørt. */
(function () {
  const lav = () => {
    const f = document.querySelector('modal-dialog.modal--main-menu .mobile-draw__footer');
    if (!f || f.querySelector('.cb-menulinks')) return;
    const d = document.createElement('div'); d.className = 'cb-menulinks';
    d.innerHTML = '<a href="/pages/kundeservice">Kundeservice</a><a href="/pages/levering">Levering og returnering</a>';
    f.appendChild(d);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lav); else lav();
})();

/* CB-CUSTOM 2026-10-18 (Michael t141u/t160u): mobilmenu niveau 2 som woodwood – flad liste af menuens eksisterende links (grupper Essentials/Sweats/Featured og billedfliser fjernes visuelt), "Se alle" sidst. Shopify-navigation urørt. */
(function () {
  const flad = () => {
    document.querySelectorAll('modal-dialog.modal--main-menu .drawer-nav--main > ul > li > details > .drawer-nav__panel > .drawer-nav__wrapper').forEach(w => {
      if (w.querySelector(':scope > .cb-flad')) return;
      const org = w.querySelector(':scope > ul.list-menu');
      if (!org || !org.querySelector('details')) return;
      const set = new Set(); const items = []; let seAlle = null;
      org.querySelectorAll('.drawer-nav__panel a.list-menu__link').forEach(a => {
        const href = a.getAttribute('href'); const t = a.textContent.trim();
        if (!href || set.has(href)) return; set.add(href);
        if (/^se al(t|le)$/i.test(t)) { seAlle = href; return; }
        if (/^joggings(æ|ae)t$/i.test(t)) return; /* t163u: Joggingsæt fjernet fra mobilmenuen */
        items.push([href, t]);
      });
      if (!items.length) return;
      const ul = document.createElement('ul'); ul.className = 'cb-flad'; ul.setAttribute('role', 'list');
      items.concat(seAlle ? [[seAlle, 'Se alle']] : []).forEach(([h, t]) => {
        const li = document.createElement('li'); const a = document.createElement('a'); a.href = h; a.textContent = t; li.appendChild(a); ul.appendChild(li);
      });
      org.classList.add('cb-flad-skjult'); org.after(ul);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', flad); else flad();
})();

/* CB-CUSTOM 2026-10-18 t171u/t175u: pakkeknapper (snippets/cb-pakke.liquid). Skjules ved tilbud. 2/3 pak opdaterer hovedpris og købsbjælke. Valgt pakke bevares ved variantskift (out144). */
(function(){
  function kr(o){return (o/100).toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g,'.')+' kr';}
  function init(box){
    if(box.dataset.cbInit)return;box.dataset.cbInit='1';
    var data={};try{data=JSON.parse(box.querySelector('[data-cb-pakke-varianter]').textContent);}catch(e){}
    var form=document.getElementById(box.dataset.form)||box.closest('form');
    var idInput=form&&form.querySelector('[name="id"]');
    var egen=box.querySelector('[data-cb-pakke-antal]');
    var knapper=[].slice.call(box.querySelectorAll('.cb-pakke__knap'));
    var sidsteId=null,valgt=knapper[0];
    var prisBlok=document.querySelector('.product-single__box__block--price .price');
    var total=document.createElement('div');total.className='price__text cb-pakke-total';
    if(prisBlok){var pt=prisBlok.querySelector('.price__text');if(pt)pt.insertAdjacentElement('afterend',total);else prisBlok.insertBefore(total,prisBlok.firstChild);}
    var kb=document.querySelector('.cb-kb__pris'),kbTotal=null;
    if(kb){kbTotal=document.createElement('p');kbTotal.className='cb-kb__pris cb-kb__pris--pakke cb-pakke-total';kb.parentNode.insertBefore(kbTotal,kb.nextSibling);}
    function variant(){return data[idInput&&idInput.value]||data[Object.keys(data)[0]];}
    function qtyFelter(){return [].slice.call(document.querySelectorAll('input[name="quantity"][form="'+box.dataset.form+'"]'));}
    function saetAntal(n){
      var f=qtyFelter();
      if(f.length){egen.disabled=true;f.forEach(function(i){if(i.value!=n){i.value=n;}});}
      else{egen.value=n;egen.disabled=false;}
    }
    function visPris(){
      var v=variant(),n=+valgt.dataset.antal,r=+valgt.dataset.rabat;
      if(!v||n<2||box.hidden){document.body.classList.remove('cb-pakke-flere');return;}
      var fuld=v.p*n,ny=Math.round(fuld*(100-r)/100);
      total.innerHTML='<span class="price__number price__number--sale"><span class="money">'+kr(ny)+'</span></span> <s class="price__compare"><span class="money">'+kr(fuld)+'</span></s>';
      if(kbTotal)kbTotal.innerHTML='<span class="cb-kb__nu cb-kb__nu--tilbud">'+kr(ny)+'</span> <s class="cb-kb__foer">'+kr(fuld)+'</s>';
      document.body.classList.add('cb-pakke-flere');
    }
    var noegle='cbPakke:'+(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
    function vaelg(k,auto){valgt=k;if(!auto){(window.cbPakkeValg=window.cbPakkeValg||{})[noegle]=k.dataset.antal;}knapper.forEach(function(x){var on=x===k;x.classList.toggle('is-valgt',on);x.setAttribute('aria-checked',on?'true':'false');});saetAntal(k.dataset.antal);visPris();}
    function opdater(){
      var id=idInput&&idInput.value;
      if(id===sidsteId)return;sidsteId=id;
      var v=variant(),tilbud=!v||(v.c&&v.c>v.p&&!box.hasAttribute('data-test'));
      box.hidden=!!tilbud;
      document.body.classList.toggle('cb-pakke-aktiv',!tilbud);
      /* out144: behold valgt pakke ved variantskift (huskes pr. produkt i siden, så den også overlever gen-rendering; ny sideindlæsning = 1 pak) */
      var gemt=(window.cbPakkeValg||{})[noegle];
      var k=tilbud?knapper[0]:(knapper.filter(function(x){return x.dataset.antal===gemt;})[0]||valgt||knapper[0]);
      vaelg(k,true);
      if(tilbud){egen.disabled=true;var f=qtyFelter();f.forEach(function(i){i.value=1;});}
    }
    knapper.forEach(function(k){k.addEventListener('click',function(){vaelg(k);});});
    /* out144: farveskift er links til søsterprodukter (.cb-farveprik); tag valgt pakke med til næste side */
    try{var ov=JSON.parse(sessionStorage.getItem('cbPakkeOverfor')||'null');sessionStorage.removeItem('cbPakkeOverfor');
      if(ov&&ov.t===noegle&&Date.now()-ov.ts<120000)(window.cbPakkeValg=window.cbPakkeValg||{})[noegle]=ov.a;}catch(e){}
    if(idInput){new MutationObserver(opdater).observe(idInput,{attributes:true,attributeFilter:['value']});}
    document.addEventListener('change',function(){setTimeout(opdater,50);});
    document.addEventListener('click',function(e){if(e.target.closest&&!e.target.closest('.cb-pakke'))setTimeout(opdater,120);});
    opdater();
  }
  function start(){document.querySelectorAll('[data-cb-pakke]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a.cb-farveprik[href*="/products/"]');if(!a)return;var k=document.querySelector('[data-cb-pakke]:not([hidden]) .cb-pakke__knap.is-valgt');if(!k||k.dataset.antal==='1')return;
    try{sessionStorage.setItem('cbPakkeOverfor',JSON.stringify({a:k.dataset.antal,t:'cbPakke:'+a.getAttribute('href').split('/products/')[1].split(/[?#\/]/)[0],ts:Date.now()}));}catch(x){}},true);
  /* out144: hvis temaet gen-renderer produktformularen ved variantskift, init de nye knapper (genvælger gemt pakke) */
  new MutationObserver(function(){if(document.querySelector('[data-cb-pakke]:not([data-cb-init])'))start();}).observe(document.documentElement,{childList:true,subtree:true});
})();

/* CB-CUSTOM 2026-10-18 t195u: promo-flise på mobil (2 kolonner, fuld bredde): flyt den efter næste produkt, hvis der ellers ville stå et tomt felt */
(function(){
  function ret(){
    var it=document.querySelector('.cb-promo-item');if(!it||!window.matchMedia('(max-width:560px)').matches)return;
    var foer=0,e=it.previousElementSibling;while(e){foer++;e=e.previousElementSibling;}
    if(foer%2===1&&it.nextElementSibling&&!it.dataset.cbFlyttet){it.parentNode.insertBefore(it.nextElementSibling,it);it.dataset.cbFlyttet='1';}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ret);else ret();
})();
